import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CentralClienteListarComponent } from './central-cliente-listar.component';

const routes: Routes = [];

@NgModule({
  imports: [RouterModule.forChild([
    {path:'', component: CentralClienteListarComponent}
  ])],
  exports: [RouterModule]
})
export class CentralClienteListarRoutingModule { }
